/*
* Like Object.keys but return proper type.
* Improved Pocock's function.
* */
export const objectKeys = <T extends object>(obj: T): (keyof T)[] => Object.keys(obj) as (keyof T)[];
